import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import AdminPanel from "../components/pages/AdminPanel";
import Home from "../components/pages/Home";
import Login from "../components/pages/Login";
import ContactUs from "../components/pages/ContactUs";
import ScrollToTop from "../components/organisms/ScrollToTop";
import { STAFF_ROLES, UserRole, hasRole } from "../utils/general";

type RoutersProp = {
  role: UserRole | null;
};

function PrivateRoute({
  children,
  role,
  allowedRoles,
}: {
  children: any;
  role: UserRole | null;
  allowedRoles: UserRole[];
}) {
  return hasRole(role, allowedRoles) ? children : <Navigate to="/adminLogin" replace />;
}

const Routers: React.FC<RoutersProp> = ({ role }) => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/adminLogin" element={<Login />} />
        <Route path="/contact" element={<ContactUs />} />

        <Route
          path="/admin"
          element={
            <PrivateRoute role={role} allowedRoles={STAFF_ROLES}>
              <AdminPanel />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default Routers;
